<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
    <FormItem label="添加方式" v-if="formValidate.id == 0">
        <RadioGroup v-model="formValidate.type" type="button">
        <Radio label="手动添加"></Radio>
        <Radio label="上传excel文件"></Radio>
        </RadioGroup>
    </FormItem>
    
    <template v-if="formValidate.id != 0">
      <FormItem label="当天最大点赞数" prop="day_max_like_count">
        <Input v-model="formValidate.day_max_like_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大评论数" prop="day_max_comment_count">
        <Input v-model="formValidate.day_max_comment_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大关注数" prop="day_max_follower_count">
        <Input v-model="formValidate.day_max_follower_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大私信数" prop="day_max_letter_count">
        <Input v-model="formValidate.day_max_letter_count" placeholder="请输入" type="number"></Input>
      </FormItem>

      <FormItem label="当天最大搜索关键字" prop="day_max_search_count">
        <Input v-model="formValidate.day_max_search_count" placeholder="请输入" type="number"></Input>
      </FormItem>
    </template>

    <template v-if="formValidate.type == '手动添加'"> 
      <FormItem label="用户名" prop="username">
        <Input v-model="formValidate.username" placeholder="请填写名称"></Input>
      </FormItem>

      <FormItem label="首页链接" prop="home_url">
        <Input v-model="formValidate.home_url" placeholder="请填写首页链接"></Input>
      </FormItem>

      <FormItem label="平台" prop="live_id" >
          <Select v-model="formValidate.live_id" clearable>
            <Option
              v-for="item in liveTypeIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="语言" prop="classify_id" >
          <Select v-model="formValidate.language" clearable>
            <Option
              v-for="item in languages"
              :value="item"
              :key="item"
              >{{ item}}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="分类" prop="classify_id" >
          <Select v-model="formValidate.classify_id" clearable>
            <Option
              v-for="item in classifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="视频分类" prop="video_classify_id" >
          <Select v-model="formValidate.video_classify_id" clearable>
            <Option
              v-for="item in shortVideoClassifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="发布视频方式" prop="push_video_type" >
          <Select v-model="formValidate.push_video_type" clearable>
            <Option
              v-for="item in pushVideoTypes"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem>

        <FormItem label="镜像">
          <RadioGroup v-model="formValidate.reversal" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
          </RadioGroup>
        </FormItem>

        <FormItem label="拉伸">
          <RadioGroup v-model="formValidate.stretch" type="button">
          <Radio label="是"></Radio>
          <Radio label="否"></Radio>
          </RadioGroup>
        </FormItem>


        <!-- <FormItem label="工作类型" prop="work_type_id" >
          <Select v-model="formValidate.work_type_id" clearable>
            <Option
              v-for="item in workTypeIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name}}</Option
            >
          </Select>
        </FormItem> -->

        <FormItem label="账号说明" >
        <Input v-model="formValidate.desc" type="textarea" placeholder="请填写账号说明"></Input>
      </FormItem>

      <template v-for="(item, index) in formValidate.keywords">
        <FormItem :label="'关键字' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="text" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handleKeywordRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handleKeywordAdd" icon="md-add">关键字</Button>
          </Col>
        </Row>
      </FormItem>

<!-- 
      <FormItem label="封面" >
          <div class="demo-upload-list" v-for="(url, index) in formValidate.uploadList">
            <template>
                <Image :src="url"/>
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click="handleView(url)"></Icon>
                    <Icon type="ios-trash-outline" @click="handleRemove(index)"></Icon>
                </div>
            </template>
          </div>
        <input type="file" accept=".jpg,.png,.jpeg"  @change="handleSourceFileChange" ref="image" />
        <modal title="View Image" v-model="visible">
          <img :src="imgName" v-if="visible" style="width: 100%">
        </modal>
      </FormItem> -->

    </template>
    <template v-else>
      <Upload 
          type="drag"
          accept="xlsx"
          ref="uploadimgs"
          :on-success="uploadSuccess"
          :action="action_url">
          <div style="padding: 20px 0">
              <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
              <p>上传excel文件</p>
          </div>
      </Upload>
    </template>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro

import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import { getOssClient } from '@/api/ossClient';

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      imgName: '',
      visible: false,
      workTypeIds:[],
      classifyIds:[],
      liveTypeIds:[],
      previewList:[],
      pushVideoTypes:[{'id': 0, "name": '摄像头'}, {'id': 1, "name": '相册'}],
      languages:["English", "Indonesia", "Chinese"],
      action_url:baseUrl + "/dy_user/upload_file",
      shortVideoClassifyIds:[],
      formValidate: {
        id: 0,
        filePath:'',
        desc:'',
        work_type_id:'',
        classify_id:'',
        live_id:'',
        username:'',
        home_url:'',
        language:'Indonesia',
        video_classify_id:'',
        type:'手动添加',
        day_max_like_count: '',
        day_max_comment_count:'',
        day_max_follower_count:'',
        day_max_letter_count:'',
        day_max_search_count:'',
        video_model_url:[],
        uploadList: [],
        keywords: [],
        push_video_type: 0,
        reversal: '是',
        stretch: '是'
      },
      ruleValidate: {
        home_url: [
          {
            required: true,
            message: '首页链接必须填写',
            trigger: 'blur'
          }
        ],   
        username: [
          {
            required: true,
            message: '用户名必须填写',
            trigger: 'blur'
          }
        ],   
        live_id: [
          {
            required: true,
            message: '平台必须选择',
            trigger: 'change'
          }
        ],   
        work_type_id: [
          {
            required: true,
            message: '工作类型必须选择',
            trigger: 'change'
          }
        ],
        video_classify_id: [
          {
            required: true,
            message: '工作类型必须选择',
            trigger: 'change'
          }
        ],  
        classify_id: [
          {
            required: true,
            message: '分类必须选择',
            trigger: 'change'
          }
        ],
        day_max_like_count: [
          {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],           
        day_max_comment_count: [
          {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],  day_max_follower_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],day_max_letter_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ],day_max_search_count:[
        {
            required: true,
            message: '数量不能为空',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
      // if (this.formValidate.type != '手动添加'){
      //   this.$refs.uploadimgs.clearFiles();
      // }else{
      //   this.$refs.image.value = ''
      // }
    }
  },
  methods: {
    handleKeywordRemove(index){
      this.formValidate.keywords.splice(index, 1)
    },
    handleKeywordAdd(){
      this.formValidate.keywords.push({ "value": '' })
    },
    handleView (name) {
      this.visible = true
      this.imgName = name;
    },
    handleRemove (index) {
      this.formValidate.uploadList.splice(index, 1)
    },
    async handleSourceFileChange (e) {
      try {
        const file = e.target.files[0];
        if (!file) return;

        var url =  await this.uploadFile(file)
        var name = ''
        if (url != null){
            var url_array = url.split("/")
            name = url_array[url_array.length - 1]
          }
        this.formValidate.uploadList.push(url)
      
      } catch (error) {
        this.$Message.error('上传失败');
      }

    },async uploadFile(file){

      // 上传文件
      let currentDate = moment().format('YYYY-MM-DD');
      const uuid = uuidv4()
      // 上传文件
      var name = file.name.substring(file.name.lastIndexOf('.'))
      const client = await getOssClient();
      const result = await client.put('short_video/' + currentDate + "/covert_audio/" + uuid + name, file);
      if (result['res']['statusCode'] == 200){
        this.$Message.info('上传成功');
        return result['res']['requestUrls'][0]
      }else{
        this.$Message.error('上传失败');
      }
      return ""

    },
    handleFormatError (file) {
      this.$Notice.warning({
          title: 'The file format is incorrect',
          desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      });
    },
    handleMaxSize (file) {
      this.$Notice.warning({
          title: 'Exceeding file size limit',
          desc: 'File  ' + file.name + ' is too large, no more than 2M.'
      });
    },
    handleBeforeUpload () {
      const check = this.uploadList.length < 5;
      if (!check) {
          this.$Notice.warning({
              title: 'Up to five pictures can be uploaded.'
          });
      }
      return check;
    },
    setEditData(params){

      // this.$refs.image.value = ''
      this.formValidate.day_max_like_count = params.day_max_like.toString()
      this.formValidate.day_max_comment_count = params.day_max_comment.toString()
      this.formValidate.day_max_follower_count = params.day_max_follower.toString()
      this.formValidate.day_max_letter_count = params.day_max_letter.toString()
      this.formValidate.day_max_search_count = params.day_max_search.toString()
      this.formValidate.video_classify_id = params.video_classify_id.toString()
      this.formValidate.work_type_id = params.short_video_work_id.toString()
      this.formValidate.classify_id = params.dy_classify_id.toString()
      this.formValidate.live_id = params.live_id.toString()
      this.formValidate.username = params.username
      this.formValidate.home_url = params.home_url
      this.formValidate.desc = params.user_desc
      this.formValidate.language = params.language
      this.formValidate.id = params.id
      this.formValidate.push_video_type = params.push_video_type
      this.formValidate.reversal = params.reversal?'是':'否'
      this.formValidate.stretch = params.stretch?'是':'否'

      this.formValidate.keywords = params.keywords != null? JSON.parse(params.keywords): []

      if (params.video_model_url != null){
        this.formValidate.uploadList = JSON.parse(params.video_model_url)
      }else{
        this.formValidate.uploadList = []
      }
    },
    setLiveType(list){
      var data = new Array()
      for (var i = 0; i < list.length; i++) {
        data[i] = { id: list[i].id.toString(), name: list[i].name }
      }
      this.liveTypeIds = data
    },
    setClassifyData(list){
      var data = new Array()
      for (var i = 0; i < list.length; i++) {
        data[i] = { id: list[i].id.toString(), name: list[i].name }
      }
      this.classifyIds = data

    },  
    setShortVideoWorkTypeData(list){
      var data = new Array()
      for (var i = 0; i < list.length; i++) {
        data[i] = { id: list[i].id.toString(), name: list[i].name }
      }
      this.workTypeIds = data
    },
    setVideoClassify(list){
      var data = new Array()
      for (var i = 0; i < list.length; i++) {
        data[i] = { id: list[i].id.toString(), name: list[i].name }
      }
      this.shortVideoClassifyIds = data
    },
    uploadSuccess(response, file, fileList){
      if (response.code == 200){
        this.formValidate.filePath = response.data
      }
    },
    handleSubmit (name) {
      this.$emit('on-ok', this.formValidate)
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>

<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
